import API from "serviceshift-ui/api-client";

export default {
  fetchMonthAvailability(_, params) {
    return API.makeRequest(`/v1/availability/available_dates`, {
      method: "GET",
      params,
    });
  },
  fetchTimeSlots(_, params) {
    return API.makeRequest(`/v1/availability/available_time_slots`, {
      method: "GET",
      params,
    });
  },
  validateCoverageArea(_, params) {
    const { email, zip_code } = params;
    return API.makeRequest("/v1/users/validate/coverage-area", {
      method: "GET",
      params: {
        email,
        zip_code,
      },
    });
  },
};
